import React from 'react';
import {useField} from 'formik';

import LetterGradePicker from './letter-grade-picker';
import NumberGradePicker from './number-grade-picker';
import PFGradePicker from './pf-grade-picker';
import MoreGradePicker from './more-grade-picker';
import TextButton from 'src/components/TextButton';

interface Props {
  closePopover: () => void;
}

const GradePicker = ({closePopover}: Props) => {
  const [, , gradeInputHelpers] = useField('grade.gradeInput');
  const [gradeType, , gradeTypeHelpers] = useField('grade.gradeType');

  let gradeSelectionComponent;
  // "L" (letter), "N" (number), "P" (passfail), "M" (more)
  switch (gradeType.value) {
    case 'L':
      gradeSelectionComponent = <LetterGradePicker closePopover={closePopover} />;
      break;
    case 'N':
      gradeSelectionComponent = <NumberGradePicker closePopover={closePopover} />;
      break;
    case 'P':
      gradeSelectionComponent = <PFGradePicker closePopover={closePopover} />;
      break;
    case 'M':
      gradeSelectionComponent = <MoreGradePicker closePopover={closePopover} />;
      break;
    default:
      gradeSelectionComponent = <LetterGradePicker closePopover={closePopover} />;
      break;
  }

  const gradeTypeOptionMap = {
    ABC: 'L',
    123: 'N',
    'P/F': 'P',
    More: 'M',
    Clear: null,
  };

  return (
    <div
      className="course-grade-picker"
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      aria-hidden="true"
    >
      <section className="course-grade-picker-grade-selection">{gradeSelectionComponent}</section>
      <section className="course-grade-picker-grade-types prefix-flex prefix-align-items prefix-flex-justify-space-around">
        {['ABC', '123', 'P/F', 'More', 'Clear'].map((key) => {
          const selected = gradeTypeOptionMap[key] === gradeType.value;

          return (
            <TextButton
              color="blue"
              tabIndex={-1}
              selected={selected}
              key={key}
              onClick={(e) => {
                e.stopPropagation();

                if (key === 'Clear') {
                  gradeInputHelpers.setValue('');
                  closePopover();
                } else {
                  gradeInputHelpers.setValue('');
                  gradeTypeHelpers.setValue(gradeTypeOptionMap[key]);
                }
              }}
              buttonName={`portfolio courses grade-picker ${key}`}
            >
              {key}
            </TextButton>
          );
        })}
      </section>
    </div>
  );
};

export default GradePicker;
